import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { toast } from "sonner";
import { handleGoogleCallback } from "@/lib/auth/google-sso";

export const Route = createFileRoute("/auth/google/callback")({
	component: GoogleCallbackPage,
});

function GoogleCallbackPage() {
	useEffect(() => {
		const processCallback = async () => {
			const result = await handleGoogleCallback();

			if (result.success) {
				// Show contextual message from backend
				// Examples: "Login successful", "Account created successfully",
				// "Account successfully linked to Google"
				toast.success(result.data.message || "Welcome!");
				// Redirect to dashboard
				window.location.href = "/";
			} else {
				console.error("Google OAuth failed:", result.error);
				toast.error(result.error.message);
				// Redirect back to login
				window.location.href = "/login";
			}
		};

		processCallback();
	}, []);

	return (
		<div className="flex min-h-screen items-center justify-center bg-muted p-6">
			<div className="w-full max-w-sm text-center">
				<div className="mb-4 text-lg font-medium">Completing sign-in...</div>
				<p className="text-sm text-muted-foreground">
					Please wait while we verify your Google account
				</p>
			</div>
		</div>
	);
}
